import React, { useEffect, useState, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Icon, ItemSelect } from '../filters/styles';
import {
  StyledClickOutside, OptionContainer, SearchInputContainer, OptionsList, InputCheckbox, Overlay,
} from './styled';

// eslint-disable-next-line max-len
const getArraysEquality = (propValue, localValue) => JSON.stringify(propValue.sort()) === JSON.stringify(localValue.sort());

const MultiSelect = ({
  field,
  label,
  searchPlaceholder,
  onChange,
  onSearch,
  onOpen,
  onClose,
  value = [],
  options = [],
  isContentDisabledWhenOpen = false,
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [isOpened, setIsOpened] = useState(false);
  const [localValue, setLocalValue] = useState(value);
  const selectContainerRef = useRef();

  const handleClose = (e) => {
    setIsOpened(false);
  };

  const listener = (event) => {
    if (event.code === 'Enter') {
      event.stopPropagation();

      handleClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', listener);

    if (!isOpened && options.length && !getArraysEquality(value, localValue)) {
      onChange(field, Array.from(new Set(localValue)));
    }

    if (isOpened) {
      setLocalValue(value);

      onOpen(field);
    } else if(onClose) {
      onClose(field);
    }

    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [isOpened]);

  const handleOpen = () => {
    setIsOpened(true);
    setSearchValue('');

    if (onSearch) {
      onSearch('');
    }
    // setAllowedOptions(options.slice(0, 10).reduce(getDefaultSearchResultMap, {}));
    // setAllowedOptions(options.slice(0, 10).reduce(getDefaultSearchResultMap, {}));
  };

  const toggle = () => {
    if (isOpened) {
      return handleClose();
    }

    return handleOpen();
  };

  const handleSearch = (e) => {
    const newSearchValue = e.target.value;

    setSearchValue(newSearchValue);

    if (onSearch) {
      onSearch(e.target.value);
    }
  };

  const handleChange = (event, id) => {
    // event.stopPropagation();

    if (event.target.checked) {
      setLocalValue([...localValue, id]);
      onChange(field, [...localValue, id], true);
    } else {
      setLocalValue(localValue.filter((item) => item !== id));
      onChange(field, localValue.filter((item) => item !== id), true);
    }
  };

  const renderOption = (items, item) => {
    const { value: optionValue, text } = item;

    const checked = localValue.includes(optionValue);

    const onOptionChange = (event) => {
      handleChange(event, optionValue);
    };

    return [
      ...items,
      (
        <span key={optionValue}>
          <InputCheckbox
            id={optionValue}
            type="checkbox"
            checked={checked}
            onChange={onOptionChange}
          />
          <label htmlFor={optionValue}>{text}</label>
        </span>
      ),
    ];
  };

  return (
    <>
      <StyledClickOutside
        onClickOutside={handleClose}
      >
        <ItemSelect ref={selectContainerRef}>
          <em>{label}</em>
          <span onClick={toggle}>
            <span>
              {/* {getLabel(value)?.length && <span>&nbsp;&nbsp;</span>} */}
              {/* {getLabel(value)} */}
            </span>
            <Icon className="icon-arrow-down" />
          </span>
          <CSSTransition
            mountOnEnter
            unmountOnExit
            in={!!isOpened}
            appear={!!isOpened}
            timeout={300}
            classNames="fade"
          >
            <OptionContainer>
              <SearchInputContainer>
                <Icon className="icon-magnifier icon-search" />
                <input
                  type="text"
                  value={searchValue}
                  onChange={handleSearch}
                  placeholder={searchPlaceholder}

                />
              </SearchInputContainer>
              <OptionsList>
                {options.reduce(renderOption, []).length ? options.reduce(renderOption, [])
                  : (<p>No options found</p>)}
              </OptionsList>
            </OptionContainer>
          </CSSTransition>
        </ItemSelect>
      </StyledClickOutside>
      {
        isOpened && isContentDisabledWhenOpen ? (
          <Overlay onClick={(e) => {
            e.stopPropagation();
          }}
          />
        ) : null
      }
    </>
  );
};

export default MultiSelect;
